import { html, ListView, View } from 'rune-ts';
import klass from './CreatorRankingList.module.scss';
import type { ICreatorRanking } from '../../../../../features/Creator/type';
import { map, pipe, take, toArray, zipWithIndex } from '@fxts/core';
import { CreatorRankingItem } from '../../../../components/cells/CreatorRankingItem/CreatorRankingItem';
import { SectionTitle } from '../../../../components/cells/SectionTitle/SectionTitle';
import { SeeMoreLinkPlugin } from '../../../../components/cells/SectionTitle/plugins';
import {
  ProductCardView,
  ProductLikeToggleEvent,
} from '@services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts';
import { makeRankScreenNavigate } from '@services/MarppleShop/shared/app/navigate';

export type CreatorRankingListProps = {
  creator_rankings: ICreatorRanking[];
  is_mobile: boolean;
  user_id?: number;
};

class CreatorRankingListView extends ListView<CreatorRankingItem> {
  override tagName = 'ul';
  ItemView = CreatorRankingItem;
}

export class CreatorRankingList extends View<CreatorRankingListProps> {
  private readonly creatorRankingListView: CreatorRankingListView;

  constructor(data: CreatorRankingListProps) {
    super(data);

    this.creatorRankingListView = new CreatorRankingListView(
      this.makeCreatorRankingItemDataList(() => false),
    );
  }

  override template() {
    const { texts } = this;
    return html`<div class="${klass.container}">
      ${new SectionTitle({
        title_props: {
          title: texts.title_main,
          sub_title: texts.sub_title,
          size: this.data.is_mobile ? 'medium' : 'xLarge',
        },
        plugins: [
          new SeeMoreLinkPlugin({
            navigate: texts.navigate,
            see_more_link: texts.see_more_link,
            size: this.data.is_mobile ? 'small' : 'xLarge',
          }),
        ],
      })}

      <div class="${klass.content}">${this.creatorRankingListView}</div>
    </div> `;
  }

  protected override onRender() {
    this.delegate(ProductLikeToggleEvent, ProductCardView, async (_, cardView) => {
      await cardView.toggleLikeButton();
    });
  }

  private makeCreatorRankingItemDataList(
    activeFn: (index: number, creator_ranking: ICreatorRanking) => boolean,
  ) {
    const { creator_rankings, user_id, is_mobile } = this.data;

    return pipe(
      creator_rankings,
      zipWithIndex,
      map(([index, creator_ranking]) => ({
        creator: creator_ranking,
        active: activeFn(index, creator_ranking),
        default_product_card_props: {
          user_id,
        },
        is_mobile,
      })),
      take(10),
      toArray,
    );
  }

  get texts() {
    const tab = ET('mps2::creator_ranking::realtime');
    const link = `/${ET.lang}/@/creator/ranking/realtime`;
    return {
      title_main: ET('mps2::creator_ranking::title_main', { tab }),
      sub_title: undefined,
      see_more_link: link,
      navigate: makeRankScreenNavigate(link),
    };
  }
}
